<template>
  <div>
    <Layout/>
    <h4>Empresas</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoEmpresa.idEmpresa" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idLocalidad" class="form-label"> Localidad</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idLocalidad" name="idLocalidad" v-model="datoEmpresa.idLocalidad">
                      <option v-for="localidad in localidads" :value="localidad.idLocalidad" :key="localidad.idLocalidad">
                        {{ localidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTipoIden" class="form-label"> Tipo Iden</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoEmpresa.idTipoIden">
                      <option v-for="tipoIden in tipoIdens" :value="tipoIden.idTipoIden" :key="tipoIden.idTipoIden">
                        {{ tipoIden.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoEmpresa.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="razonSocial" class="form-label">RazonSocial</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="razonSocial" name="razonSocial" v-model="datoEmpresa.razonSocial" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoEmpresa.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreCorto" class="form-label">NombreCorto</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombreCorto" name="nombreCorto" v-model="datoEmpresa.nombreCorto" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label">Dirección</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="direccion" name="direccion" v-model="datoEmpresa.direccion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="telefono" class="form-label">Telefono</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="telefono" name="telefono" v-model="datoEmpresa.telefono" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="email" class="form-label">Email</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="email" name="email" v-model="datoEmpresa.email" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="ciudad" class="form-label">Ciudad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="ciudad" name="ciudad" v-model="datoEmpresa.ciudad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoEmpresa.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoEmpresa.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoEmpresa.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoEmpresa.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="numeroCita" class="form-label">NumeroCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="numeroCita" name="numeroCita" v-model="datoEmpresa.numeroCita" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="numeroAtencion" class="form-label">NumeroAtencion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="numeroAtencion" name="numeroAtencion" v-model="datoEmpresa.numeroAtencion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="numeroAsiento" class="form-label">NumeroAsiento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="numeroAsiento" name="numeroAsiento" v-model="datoEmpresa.numeroAsiento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="numeroFactura" class="form-label">NumeroFactura</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="numeroFactura" name="numeroFactura" v-model="datoEmpresa.numeroFactura" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="sistema" class="form-label">Sistema</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="sistema" name="sistema" v-model="datoEmpresa.sistema" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="unicodigo" class="form-label">Unicodigo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="unicodigo" name="unicodigo" v-model="datoEmpresa.unicodigo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarEmpresa" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditEmpresa" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdReferencia</th>
          <th scope="col">IdMotivoRef</th>
          <th scope="col">IdEmpresaOrigen</th>
          <th scope="col">IdEmpresaDestino</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdMedico</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaRef</th>
          <th scope="col">Hora</th>
          <th scope="col">Tipo</th>
          <th scope="col">Motivo</th>
          <th scope="col">Resumen</th>
          <th scope="col">Hallazgos</th>
          <th scope="col">Tratamiento</th>
          <th scope="col">Justificada</th>
          <th scope="col">Estado</th>
          <th scope="col">PersonaFechaReg</th>
          <th scope="col">MotivoRefNombre</th>
          <th scope="col">MedicoFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="referencia in datosPaginados" :key="referencia.idReferencia">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(referencia.idReferencia)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(referencia.idReferencia)" title="Editar">edit_square</i></td>
          <td>{{referencia.idReferencia}}</td>
          <td>{{referencia.idMotivoRef}}</td>
          <td>{{referencia.idEmpresaOrigen}}</td>
          <td>{{referencia.idEmpresaDestino}}</td>
          <td>{{referencia.idPersona}}</td>
          <td>{{referencia.idMedico}}</td>
          <td>{{getFormattedDate(referencia.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(referencia.fechaRef, 'DD/MM/YYYY')}}</td>
          <td>{{referencia.hora}}</td>
          <td>{{referencia.tipo}}</td>
          <td>{{referencia.motivo}}</td>
          <td>{{referencia.resumen}}</td>
          <td>{{referencia.hallazgos}}</td>
          <td>{{referencia.tratamiento}}</td>
          <td>{{referencia.justificada}}</td>
          <td>{{referencia.estado}}</td>
          <td>{{getFormattedDate(referencia.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{referencia.motivoRefNombre}}</td>
          <td>{{getFormattedDate(referencia.medicoFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteEmpresa(referencia.idReferencia)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idReferencia" class="form-label">IdReferencia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idReferencia" name="idReferencia" v-model="datoReferencia.idReferencia" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoReferencia.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idMotivoRef" class="form-label"> Motivo Ref</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMotivoRef" name="idMotivoRef" v-model="datoReferencia.idMotivoRef">
                      <option v-for="motivoRef in motivoRefs" :value="motivoRef.idMotivoRef" :key="motivoRef.idMotivoRef">
                        {{ motivoRef.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresaOrigen" class="form-label"> Empresa Origen</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEmpresaOrigen" name="idEmpresaOrigen" v-model="datoReferencia.idEmpresaOrigen">
                      <option v-for="empresaOrigen in empresaOrigens" :value="empresaOrigen.idEmpresaOrigen" :key="empresaOrigen.idEmpresaOrigen">
                        {{ empresaOrigen.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresaDestino" class="form-label"> Empresa Destino</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEmpresaDestino" name="idEmpresaDestino" v-model="datoReferencia.idEmpresaDestino">
                      <option v-for="empresaDestino in empresaDestinos" :value="empresaDestino.idEmpresaDestino" :key="empresaDestino.idEmpresaDestino">
                        {{ empresaDestino.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoReferencia.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedico" name="idMedico" v-model="datoReferencia.idMedico">
                      <option v-for="medico in medicos" :value="medico.idMedico" :key="medico.idMedico">
                        {{ medico.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoReferencia.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaRef" class="form-label">FechaRef</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaRef" name="fechaRef" v-model="datoReferencia.fechaRef" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="hora" class="form-label">Hora</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="hora" name="hora" v-model="datoReferencia.hora" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoReferencia.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="motivo" name="motivo" v-model="datoReferencia.motivo" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="resumen" class="form-label">Resumen</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="resumen" name="resumen" v-model="datoReferencia.resumen" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="hallazgos" class="form-label">Hallazgos</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="hallazgos" name="hallazgos" v-model="datoReferencia.hallazgos" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tratamiento" class="form-label">Tratamiento</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="tratamiento" name="tratamiento" v-model="datoReferencia.tratamiento" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="justificada" class="form-label">Justificada</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="justificada" name="justificada" v-model="datoReferencia.justificada" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarReferencia" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditReferencia" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      empresas : [],
      datoEmpresa : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idEmpresa: '',
      localidads : [],
      tipoIdens : [],
// Variables master
// Variables details
      referencias : [],
      datoReferencia : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      atencions : [],
      motivoRefs : [],
      empresaOrigens : [],
      empresaDestinos : [],
      personas : [],
      medicos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idEmpresa = this.$route.params.p_idempresa
    this.abrirEditar(this.p_idEmpresa)
    this.getDataPagina(this.paginaActual)
    this.fetchLocalidads()
    this.fetchTipoIdens()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idLocalidad'
        ,'idTipoIden'
        ,'documento'
        ,'razonSocial'
        ,'nombre'
        ,'nombreCorto'
        ,'direccion'
        ,'telefono'
        ,'email'
        ,'ciudad'
        ,'numeroCita'
        ,'numeroAtencion'
        ,'numeroAsiento'
        ,'numeroFactura'
        ,'sistema'
        ,'unicodigo'
      ];
      const requiredFieldsText = [
        'idLocalidad'
        ,'idTipoIden'
        ,'documento'
        ,'razonSocial'
        ,'nombre'
        ,'nombreCorto'
        ,'direccion'
        ,'telefono'
        ,'email'
        ,'ciudad'
        ,'numeroCita'
        ,'numeroAtencion'
        ,'numeroAsiento'
        ,'numeroFactura'
        ,'sistema'
        ,'unicodigo'
      ];
      return validarForm(this.datoEmpresa, requiredFields, requiredFieldsText);
    },
    async guardarEmpresa(){
      if(this.validarForm() === 1){
        try {
          this.datoEmpresa.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/empresas', this.datoEmpresa)
          swal("Correcto!", "Empresa creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditEmpresa(){
      if(this.validarForm() === 1){
        try {
          await api.post('/empresas', this.datoEmpresa)
          swal("Correcto!", "Empresa creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoEmpresa={}
      this.titulo   = 'Crear Empresas'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idEmpresa){
      this.modalWindow = true
      if(idEmpresa != null){    
           api.get('/vwempresas/'+idEmpresa).then(resp=>{
          this.datoEmpresa = resp.data;
           });
      }
      this.titulo   = 'Editar Empresas'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarEmpresa(){
      this.$router.push('/Empresa')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.referencias.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwreferencias/nombre/'+this.nombreBusqueda).then(response=>{
          this.referencias=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.referencias.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwreferencias').then(response=>{
      this.referencias=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.referencias.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idLocalidad'
        ,'idTipoIden'
        ,'documento'
        ,'razonSocial'
        ,'nombre'
        ,'nombreCorto'
        ,'direccion'
        ,'telefono'
        ,'email'
        ,'ciudad'
        ,'numeroCita'
        ,'numeroAtencion'
        ,'numeroAsiento'
        ,'numeroFactura'
        ,'sistema'
        ,'unicodigo'
      ];
      const requiredFieldsText = [
        'idLocalidad'
        ,'idTipoIden'
        ,'documento'
        ,'razonSocial'
        ,'nombre'
        ,'nombreCorto'
        ,'direccion'
        ,'telefono'
        ,'email'
        ,'ciudad'
        ,'numeroCita'
        ,'numeroAtencion'
        ,'numeroAsiento'
        ,'numeroFactura'
        ,'sistema'
        ,'unicodigo'
      ];
      return validarForm(this.datoEmpresa, requiredFields, requiredFieldsText);
    },
    async guardarReferencia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/referencias', this.datoReferencia)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Referencia creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditReferencia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/referencias', this.datoReferencia)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Referencia creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoReferencia={}
      this.titulo   = 'Crear Empresas'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idReferencia){
      this.modalWindow = true
      if(idReferencia != null){    
           api.get('/vwreferencias/'+idReferencia).then(resp=>{
          this.datoReferencia = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Empresas'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idReferencia){
      this.modalWindow = true
      if(idReferencia != null){
        this.$router.push('/referenciamd/'+idReferencia)
      }
    },
    async deleteReferencia (idReferencia) {
      try{
        await api.delete('/referencias/'+idReferencia)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchLocalidads() {
      fetch('http://localhost:8080/api/v1/localidads')
        .then(response => response.json())
        .then(data => {
          this.localidads = data;
        })
        .catch(error => {
          console.error('Error fetching localidads:', error);
        });
    },
    fetchTipoIdens() {
      fetch('http://localhost:8080/api/v1/tipoidens')
        .then(response => response.json())
        .then(data => {
          this.tipoIdens = data;
        })
        .catch(error => {
          console.error('Error fetching tipoIdens:', error);
        });
    },
    fetchAtencions() {
      fetch('http://localhost:8080/api/v1/atencions')
        .then(response => response.json())
        .then(data => {
          this.atencions = data;
        })
        .catch(error => {
          console.error('Error fetching atencions:', error);
        });
    },
    fetchMotivoRefs() {
      fetch('http://localhost:8080/api/v1/motivorefs')
        .then(response => response.json())
        .then(data => {
          this.motivoRefs = data;
        })
        .catch(error => {
          console.error('Error fetching motivoRefs:', error);
        });
    },
    fetchEmpresaOrigens() {
      fetch('http://localhost:8080/api/v1/empresaorigens')
        .then(response => response.json())
        .then(data => {
          this.empresaOrigens = data;
        })
        .catch(error => {
          console.error('Error fetching empresaOrigens:', error);
        });
    },
    fetchEmpresaDestinos() {
      fetch('http://localhost:8080/api/v1/empresadestinos')
        .then(response => response.json())
        .then(data => {
          this.empresaDestinos = data;
        })
        .catch(error => {
          console.error('Error fetching empresaDestinos:', error);
        });
    },
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchMedicos() {
      fetch('http://localhost:8080/api/v1/medicos')
        .then(response => response.json())
        .then(data => {
          this.medicos = data;
        })
        .catch(error => {
          console.error('Error fetching medicos:', error);
        });
    },
  },
}
</script>
